import React from "react";

const UserAvatar = ({
  userName,
  onClick,
  isActive = false,
  className = "",
}) => {
  const getInitials = (name) => {
    if (!name || name.trim() === "") return "U";
    return name.charAt(0).toUpperCase();
  };

  return (
    <button
      onClick={onClick}
      className={`p-1.5 rounded-lg cursor-pointer transition-colors ${
        isActive ? "bg-orange-50" : "hover:bg-gray-100"
      } ${className}`}
      aria-label="User menu"
    >
      <div className="w-8 h-8 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center text-sm font-semibold text-white shadow-sm">
        {getInitials(userName)}
      </div>
    </button>
  );
};

export default UserAvatar;
